<template>
  <v-container fluid>
    <div class="container">
      <h2>{{ $t("app.temp-home.contact") }}</h2>
      <div class="contact-leftcol">
        <p>{{ hospital.name }}</p>
        <br />
        <p>{{ hospital.streetName + " " + hospital.streetNumber }}</p>
        <p>{{ hospital.postalCode + " " + hospital.city }}</p>
        <p>{{ hospital.addressLineExtra }}</p>
        <p>
          <a
            class="highlight-link"
            :href="
              encodeURI(
                `https://www.google.com/maps/search/?api=1&query=${hospital.streetName} ${hospital.streetNumber}, ${hospital.postalCode} ${hospital.city}`
              )
            "
            target="_blank"
            rel="noopener noreferrer"
            >Google Maps</a
          >
        </p>
        <br />
        <p>
          {{ $t("app.temp-home.email") }}:
          <a class="highlight-link" :href="'mailto:' + hospital.email">{{ hospital.email }}</a>
        </p>
      </div>
      <div class="contact-rightcol">
        <p>
          {{ $t("app.temp-home.phone") }}:
          <a :href="'tel:' + hospital.phonePrimary">{{
            hospital.phonePrimary
          }}</a>
        </p>
        <p>
          <a :href="'tel:' + hospital.phoneSecondary">{{
            hospital.phoneSecondary
          }}</a>
        </p>
        <p>{{ hospital.phoneOther }}</p>
        <p>
          <a :href="hospital.link" target="_blank" rel="noopener noreferrer">{{
            $t("app.temp-home.site")
          }}</a>
        </p>
      </div>
      <div class="button-container" v-if="$store.getters.user.role === 'p'">
        <a :href="'tel:' + hospital.phonePrimary" class="button">{{
          $t("app.temp-home.action-call")
        }}</a>
      </div>

      <div v-if="nurses.length > 0">
        <h2>{{ $t("app.temp-home.staff") }}</h2>
        <div class="personnel-container">
          <div v-for="nurse in nurses" :key="nurse.id" class="nurse-card">
            <Person
              :person="nurse"
              noLink
              @click.native="$modal.show(`nurse${nurse.id}-modal`)"
            />
            <modal
              class="comment"
              :name="`nurse${nurse.id}-modal`"
              width="90%"
              height="auto"
            >
              <Button
                class="close"
                @click.native="$modal.hide(`nurse${nurse.id}-modal`)"
                margin="10px"
                color="#31b9be"
                bgcolor="transparent"
                width="30px"
                padding="0"
                icon="close-blue"
              ></Button>
              <p class="info">
                {{ `${$t("app.temp-home.nickname")}: ${nurse.nickName}` }}
              </p>
              <h3>{{ nurse.firstName }} {{ nurse.lastName }}</h3>
              <p class="bio" v-if="nurse.bio">{{ nurse.bio }}</p>
            </modal>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { neoparentNurses } from "@/api";

export default {
  name: "neoparent-hospital",
  data() {
    return {
      hospital: this.$store.getters.user.hospital,
      nurses: []
    };
  },
  mounted() {
    neoparentNurses
      .getAllNurses(this.hospital.id)
      .then(result => {
        this.consoleLog(result);
        this.nurses = result.data.nurses;
      })
      .catch(err => {
        this.consoleLog(err);
      });
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.container {
  text-align: left;
  padding: 0rem 5%;
}

.contact-leftcol,
.contact-rightcol {
  width: 50%;
  display: flex;
  flex-direction: column;
  float: left;
}

a {
  color: #00a9b3;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
}

.highlight-link {
  color: #0066cc !important;
  text-decoration: underline;
}

p {
  margin: 0;
  line-height: 150%;
}
.button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 30px;
  clear: both;
  width: 100%;

  .button {
    background-color: #00a9b3;
    color: #fff;
    border-radius: 20px;
    justify-self: center;
    padding: 5px 25px;

    &:focus,
    &:hover {
      background-color: darken($color: #00a9b3, $amount: 10);
    }
  }
}

.personnel-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  & > div {
    width: 50%;
    text-align: center;
    min-height: 50px;
  }

  img {
    margin: 35px auto 0 auto;
    max-height: 200px;
    width: auto;
    border: 1px solid #e05484;
  }

  .info {
    color: #c6c6c6;
  }

  .bio {
    text-align: left;
    max-width: 250px;
    margin: 0 auto 36px auto;
  }
}
</style>
